import React, { useState } from 'react';

import { makeUrl, endpoints } from "./endpoints.js";
import { fetchWithJWT } from './requests.js';
import { getJWTUsername } from './storage.js';

function ChangePassword() {
  const defaultFormData = {
    OldPassword: "",
    NewPassword1: "",
    NewPassword2: "",
  };

  const [formData, setFormData] = useState(defaultFormData);
  const [feedback, setFeedback] = useState("");

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    let formDataWithUsername = { ...formData, "Username": getJWTUsername() };

    fetchWithJWT(
      endpoints.postChangePassword,
      "POST",
      formDataWithUsername,
      (data) => {
        setFormData(defaultFormData);
        setFeedback("Password changed");
      },
      (a, b, c) => {
        setFeedback("Error occured");
      });
  }

  return (
    <div className="container block">
      <h2 className="title has-text-weight is-4 honey-text-font-family honey-text-common">
        Change Password
      </h2>
      <form action="" className="block">
        <div className="level">
          <div className="level-left">
            <div className="level-item">
              <div className="field">
                <input
                  className="input honey-input-focus-color"
                  type="password"
                  name="OldPassword"
                  placeholder="Old Password"
                  value={formData.OldPassword}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="level-item">
              <div className="field">
                <input
                  className="input honey-input-focus-color"
                  type="password"
                  name="NewPassword1"
                  placeholder="New Password"
                  value={formData.NewPassword1}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="level-item">
              <div className="field">
                <input
                  className="input honey-input-focus-color"
                  type="password"
                  name="NewPassword2"
                  placeholder="New Password Again"
                  value={formData.NewPassword2}
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div className="level-right">
            <div className="level-item">
              <button className="button honey-button" onClick={handleSubmit}>Change</button>
            </div>
          </div>
        </div>
      </form>
      {feedback !== "" &&
        <div className="block">
          <div className="notification">
            {feedback}
          </div>
        </div>
      }
    </div>
  );
}

export default ChangePassword;
